import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function boldStyle({ $bold }: ButtonStyleProps) {
  if ($bold) {
    return css`
      font-weight: 400;
    `;
  }
}
